<template>
  <div>
    <!-- {{ scope.row.orderId }} -->
    <el-table
      :data="userList"
      style="width: 100%"
      height="calc(100vh - 353px)"
      :row-class-name="tableRowClassName"
    >
      <el-table-column
        prop="tenantName"
        fixed="left"
        label="租户名称"
        align="center"
      />
      <el-table-column
        label="平仓订单ID"
        fixed="left"
        min-width="170"
        align="left"
      >
        <template slot-scope="scope">
          {{ scope.row.orderId }}
          <!-- <el-popover
            trigger="hover"
            placement="top-start"
            popper-class="tip_box"
          >
            <img :src="order" slot="reference" alt="" class="pointer" />
            <div class="tip_box_item">
              {{ scope.row.orderId }}
              <img
                :src="copyImg"
                alt=""
                @click="handleCopy(scope.row.orderId)"
              />
            </div>
          </el-popover> -->
        </template>
      </el-table-column>

      <!-- <el-table-column prop="userType" label="用户身份">
        <template slot-scope="scope">
          <span v-if="scope.row.userType == '普通用户'" class="red">{{
            scope.row.userType
          }}</span>
          <span v-else class="cc">{{ scope.row.userType }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="userId"
        label="用户UID"
        align="center"
        fixed="left"
        min-width="160"
      >
        <template slot-scope="scope">
          <span
            @click="showBox(scope.row, 2)"
            :class="{
              tdRed: scope.row.mark == true,
              blue: scope.row.mark != true,
              myTd: true,
            }"
            >{{ scope.row.userId }}</span
          >
        </template>
      </el-table-column>

      <el-table-column
        prop="channelUserId"
        label="合伙人UID"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span @click="showBox(scope.row, 1)" class="myTd blue">{{
            scope.row.channelUserId
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="symbol"
        label="合约名称"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.symbol }}
        </template>
      </el-table-column>
      <el-table-column
        prop="symbol"
        label="杠杆倍数"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.leverage }}
        </template>
      </el-table-column>

      <el-table-column
        prop="positionType"
        label="仓位模式"
        align="center"
        min-width="80"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.positionType == 1">全仓</span>
          <span v-else>逐仓</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="profit"
        label="结算盈亏"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.profit }}
        </template>
      </el-table-column>
      <el-table-column
        prop="orderSide"
        label="订单方向"
        align="center"
        min-width="80"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.orderSide == 1" class="green">买</span>
          <span v-else class="red">卖</span>
        </template>
      </el-table-column>

      <el-table-column label="仓位方向" align="center" min-width="100">
        <template slot-scope="scope">
          <!-- <span type="success" v-if=" scope.row.orderSide==1">买入{{ scope.row.positionSide==1?'开多':'平空'}}</span>
         <span type="danger" v-if=" scope.row.orderSide==2">卖出{{ scope.row.positionSide==1?'开空':'平多'}}</span> -->
          <span
            class="green"
            v-if="scope.row.orderSide == 1 && scope.row.positionSide == 1"
            >买入开多
          </span>
          <span
            class="red"
            v-if="scope.row.orderSide == 1 && scope.row.positionSide == 2"
            >买入平空</span
          >
          <span
            class="green"
            v-if="scope.row.orderSide == 2 && scope.row.positionSide == 1"
            >卖出平多
          </span>
          <span
            class="red"
            v-if="scope.row.orderSide == 2 && scope.row.positionSide == 2"
            >卖出开空</span
          >
        </template>
      </el-table-column>
      <el-table-column label="平仓价格" align="center" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.price }}
          <!-- {{ scope.row.symbol.split("_")[1].toUpperCase() }} -->
        </template>
      </el-table-column>
      <el-table-column label="平仓数量" align="center" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.amount }}
          <!-- {{ scope.row.symbol.split("_")[0].toUpperCase() }} -->
        </template>
      </el-table-column>
      <el-table-column label="手续费" align="center" min-width="160">
        <template slot-scope="scope">{{ scope.row.fee }}</template>
      </el-table-column>
      <el-table-column label="平仓时间" align="right" min-width="160">
        <template slot-scope="scope">{{
          scope.row.updatedTime | moment
        }}</template>
      </el-table-column>
      <!-- <el-table-column  label="是否展示备注">
        <template slot-scope="scope">
          <span v-if="scope.row">{{ scope.row.type}}</span>
        </template>
      </el-table-column> -->

      <!-- <el-table-column label="操作" >
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="goDetail(scope.row)">资产明细</el-button>
          <el-button size="mini" type="text" @click="handleUpdate(scope.row)" v-if="scope.row.type==0"
            >修改备注</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      ></pagination>
    </div>
    <!-- <update-dialog
      :val="userinfoDetail"
      :updateForm="updateForm"
    ></update-dialog> -->

    <!-- 编辑用户信息dialog -->
    <el-dialog
      title="修改备注"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div class="main">
        <el-card class="box-card">
          <div>备注信息</div>
          <div class="content">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入备注信息"
              maxlength="50"
              show-word-limit
              v-model="textarea2"
            >
            </el-input>
          </div>
          <div class="btn">
            <el-button size="small" type="primary" @click="add"
              >添 加</el-button
            >
          </div>
        </el-card>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
    <UserDetailDialog :id="id" :type="type" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import Pagination from "components/pagination";
import updateDialog from "../updatedialog";
import order from "@/assets/order.png";
import copyImg from "@/assets/copy.png";
import UserDetailDialog from "components/userDetailDialog";

import tip from "@/assets/partnerCenter/tip.png";
export default {
  name: "UserList",
  data() {
    return {
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: "",
      selectedForUserType: {},
      centerDialogVisible: false,
      textarea2: "",
      order,
      tip,
      copyImg,
      type: "",
      id: "",
    };
  },
  components: {
    Pagination,
    updateDialog,
    UserDetailDialog,
  },
  methods: {
    ...mapActions("closingCommission", ["addRemark"]),
    ...mapMutations("closingCommission", [
      "setUserinfoDetailDialogVisible",
      "setUserinfoDetail",
    ]),
    ...mapMutations("contractassets", ["setUserDetailInfoVisible"]),

    handleCopy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      // console.log(oInput.value)
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success",
        center: true,
      });
      oInput.remove();
    },
    pageChanged(pagination) {
      this.$emit("refresh", pagination);
    },
    handleUpdate(row) {
      this.updateForm = row;
      // this.setUserinfoDetail(row);
      // this.setUserinfoDetailDialogVisible(true);
      this.centerDialogVisible = true;
      this.textarea2 = row.remarks;
    },
    add() {
      this.addRemark({
        channelId: this.userInfo.channelId,
        userId: this.updateForm.id,
        remarks: this.textarea2,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success("添加成功");
          (this.textarea2 = ""), (this.centerDialogVisible = false);
          this.$emit("refresh");
        }
      });
    },
    goDetail(row) {
      this.$router.push({ path: `/home/closingCommission/detail`, query: row });
    },
    handleCopy(id) {
      this.copy(id);
    },
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success",
        center: true,
      });
      oInput.remove();
    },
    showBox(row, type) {
      this.type = type;
      this.id = type == 2 ? row.userId : row.channelUserId;
      this.setUserDetailInfoVisible(true);
    },
    tableRowClassName({ row }) {
      if (row.mark == true) {
        return "redRow";
      }
      return "";
    },
  },
  computed: {
    // ...mapGetters('user', ['userList']),
    ...mapState(["userInfo"]),
    ...mapState("closingCommission", [
      "pagination",
      "userList",
      "totalCount",
      "userinfoDetail",
      "userinfoDetailDialogVisible",
    ]),
  },
};
</script>

<style lang="less" src="../../../../../styles/table.less" scoped></style>
